import { Menu as ChackraCheckBoxMenu } from '@chakra-ui/react';

export const CheckBoxMenuRoot = ChackraCheckBoxMenu.Root;
export const CheckBoxMenuTrigger = ChackraCheckBoxMenu.Trigger;
export const CheckBoxMenuPositioner = ChackraCheckBoxMenu.Positioner;
export const CheckBoxMenuContent = ChackraCheckBoxMenu.Content;
export const CheckBoxMenuItemGroup = ChackraCheckBoxMenu.ItemGroup;
export const CheckBoxMenuItemGroupLabel = ChackraCheckBoxMenu.ItemGroupLabel;
export const CheckBoxMenuItem = ChackraCheckBoxMenu.CheckboxItem;
export const CheckBoxMenuItemIndicator = ChackraCheckBoxMenu.ItemIndicator;